const actions = {

    QR_DASHBOARD_DATA_BEGIN : 'QR_DASHBOARD_DATA_BEGIN',
    QR_DASHBOARD_DATA_SUCCESS : 'QR_DASHBOARD_DATA_SUCCESS',
    QR_DASHBOARD_DATA_ERR : 'QR_DASHBOARD_DATA_ERR',
    
    QR_PAYMENT_INFO_DATA_BEGIN : 'QR_PAYMENT_INFO_DATA_BEGIN',
    QR_PAYMENT_INFO_DATA_SUCCESS: 'QR_PAYMENT_INFO_DATA_SUCCESS',
    QR_PAYMENT_INFO_DATA_ERR : 'QR_PAYMENT_INFO_DATA_ERR',

    getQRDashboardDataBegin: () => {
        return {
            type: actions.QR_DASHBOARD_DATA_BEGIN,
        };
    },
    
    getQRDashboardDataSuccess: (data) => {
        return {
            type: actions.QR_DASHBOARD_DATA_SUCCESS,
            data,
        };
    },
    
    getQRDashboardDataErr: (err) => {
        return {
            type: actions.QR_DASHBOARD_DATA_ERR,
            err,
        };
    },
 
    getQRPaymentInfoDataBegin: () => {
        return {
            type: actions.QR_PAYMENT_INFO_DATA_BEGIN,
        };
    },

    getQRPaymentInfoDataSuccess: (data) => {
        return {
            type: actions.QR_PAYMENT_INFO_DATA_SUCCESS,
            data,
        };
    },

    getQRPaymentInfoDataErr: (err) => {
        return {
            type: actions.QR_PAYMENT_INFO_DATA_ERR,
            err,
        };
    },

};

export default actions;
